import { render, staticRenderFns } from "./BotSettingsCard.vue?vue&type=template&id=f5732722"
import script from "./BotSettingsCard.vue?vue&type=script&lang=ts"
export * from "./BotSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports